import { Heading } from '@/src/packages/components/ui/Heading';

export const ProductTitle = ({ title }: { title: string }) => {
  return (
    <Heading as="h1" className="text-2xl font-medium">
      {title}
    </Heading>
  );
};
